/*--- created as part of FUSS-1663 maintenance page before Login---*/
(function () {
  'use strict';

  angular.module('eclipseApp.core').factory('flowMaintenanceService', ['$http', 'uteEndpoint', '$q', function ($http, uteEndpoint, $q) {
    var service = {};
    service.flowDetail = {};
    service.flowDetail.isSwitchForLogin = false;
    service.flowDetail.switchForCheckUser = false;
    var userType = 'consumer';

    service.resetFlowDetails = function() {
      service.flowDetail.isSwitchForLogin = false;
      service.flowDetail.switchForCheckUser = false;
    }

    service.getPreferencesBeforeLogin = function () {
        var deferred = $q.defer();
        $http({
            url: uteEndpoint('v1/maintenance/before/login/switch/details'),
            method: 'POST',
            data: $.param({
              appType: 'fido.ca'
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (_.isEmpty(data)) {
              deferred.reject(data);
              return deferred.promise;
            }
            else {
              _.each(data, function(value){
                  if (value.maintenanceIndicator != null && value.maintenanceIndicator.toUpperCase() ==='Y' &&
                  value.flowName!= null && 'PRESIGNLOGIN' === value.flowName.toUpperCase() && userType === value.userType) { //For Login flow
                  service.flowDetail.isSwitchForLogin = true;
                  }
                  if (value.maintenanceIndicator != null && value.maintenanceIndicator.toUpperCase() ==='N' &&
                  value.flowName!= null && 'CHECKUSERAPI' === value.flowName.toUpperCase() && userType === value.userType){
                    service.flowDetail.switchForCheckUser = true;
                  }
              })
            }
            deferred.resolve();
        }).error(function(data){
          deferred.reject(data);


        });

      return deferred.promise;
    };
    return service;
  }]);
})();
